// Get the redirect URL for authentication
export const getRedirectUrl = () => {
  const domain = import.meta.env.VITE_DOMAIN || window.location.host;
  const url = `https://${domain}/auth/callback`;
  console.log('Auth redirect URL:', url);
  return url;
};